<template>
  <div class="col s7">
    <table class="rating-show">
			<tr>
					<td class="review-rating-label">5 stars</td>
					<td><span class="review-rating-progress"> <span :style="{width: calculateProgress(countReviews5Star) + '%'}"></span></span></td>
					<td class="review-rating-total"> {{ countReviews5Star }}</td>
			</tr>
			
			<tr>
					<td class="review-rating-label">4 stars</td>
					<td><span class="review-rating-progress"> <span :style="{width: calculateProgress(countReviews4Star) + '%'}"></span></span></td>
					<td class="review-rating-total"> {{ countReviews4Star }}</td>
			</tr>
			<tr>
					<td class="review-rating-label">3 stars</td>
					<td><span class="review-rating-progress"> <span :style="{width: calculateProgress(countReviews3Star) + '%'}"></span></span></td>
					<td class="review-rating-total"> {{ countReviews3Star }}</td>
			</tr>
			<tr>
					<td class="review-rating-label">2 stars</td>
					<td><span class="review-rating-progress"> <span :style="{width: calculateProgress(countReviews2Star) + '%'}"></span></span></td>
					<td class="review-rating-total"> {{ countReviews2Star }}</td>
			</tr>
			<tr>
					<td class="review-rating-label">1 stars</td>
					<td><span class="review-rating-progress"> <span :style="{width: calculateProgress(countReviews1Star) + '%'}"></span></span></td>
					<td class="review-rating-total"> {{ countReviews1Star }}</td>
			</tr>
		</table>
	</div>
         
</template>

<style src="./ReputationData.component.css" scoped>
</style>

<script>
export default {
  name: "ReputationShow",
  props: ["reviews"],
  components: {},
  data() {
    return {
      reviewsAll: [],
      reviewsPositives: [],
      reviewsNegatives: [],
      reviewsNegatives: [],
      countReviews1Star: 0,
      countReviews2Star: 0,
      countReviews3Star: 0,
      countReviews4Star: 0,
      countReviews5Star: 0,
      averageBetween: 0
    };
  },
  methods: {
    calculateProgress(star) {
      if (star <= 0) return 0;

      return star / this.reviewsAll.length * 100;
    }
  },
  watch: {
    reviews(value) {
      if (value.length > 0) {
        this.reviewsAll = value;

        this.reviewsPositives = value.filter(item => item.countStar > 3);

        this.reviewsNegatives = value.filter(item => item.countStar <= 3);

        this.countReviews1Star = value.filter(
          item => item.countStar <= 1
        ).length;

        this.countReviews2Star = value.filter(
          item => item.countStar <= 2 && item.countStar > 1
        ).length;

        this.countReviews3Star = value.filter(
          item => item.countStar <= 3 && item.countStar > 2
        ).length;

        this.countReviews4Star = value.filter(
          item => item.countStar <= 4 && item.countStar > 3
        ).length;

        this.countReviews5Star = value.filter(
          item => item.countStar > 4
        ).length;

        this.averageBetween =
          value.reduce((a, b) => {
            return { countStar: a.countStar + b.countStar };
          }).countStar / value.length;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Marketplace/Widget/ReputationData/ReputationShow.vue